export const formatCurrency = (amount: number, currency: string = 'ARS'): string => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatNumber = (amount: number): string => {
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const parseCurrency = (value: string): number => {
  // Remove currency symbols and parse as number
  const cleanValue = value.replace(/[^\d.,]/g, '');
  const normalizedValue = cleanValue.replace(',', '.');
  return parseFloat(normalizedValue) || 0;
};

export const calculatePercentage = (value: number, total: number): number => {
  if (total === 0) return 0;
  return (value / total) * 100;
};

export const calculateCompoundInterest = (
  principal: number,
  rate: number,
  time: number,
  monthlyContribution: number = 0
): number => {
  const monthlyRate = rate / 100 / 12;
  const months = time * 12;
  
  // Future value of principal
  const futureValuePrincipal = principal * Math.pow(1 + monthlyRate, months);
  
  // Future value of monthly contributions (annuity)
  const futureValueAnnuity = monthlyContribution > 0 
    ? monthlyContribution * ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate)
    : 0;
  
  return futureValuePrincipal + futureValueAnnuity;
};

export const calculateMonthlyPayment = (
  principal: number,
  rate: number,
  time: number
): number => {
  const monthlyRate = rate / 100 / 12;
  const months = time * 12;
  
  if (monthlyRate === 0) {
    return principal / months;
  }
  
  return principal * (monthlyRate * Math.pow(1 + monthlyRate, months)) / 
         (Math.pow(1 + monthlyRate, months) - 1);
};
